import { NgModule } from '@angular/core';
import { CapitalizeFirstLetterEachPipe } from './capitalize-first-letter-each.pipe';
import { KeepOnlyThreeMonthCharacterPipe } from './keep-only-three-month-character.pipe';
import { NoCommaPipe } from './no-comma.pipe';
import { PrintUnitPipe } from './print-unit.pipe';
import { RemoveDoubleDecimalZeroPipe } from './remove-double-decimal-zero.pipe';
import { RemoveUnitPipe } from './remove-unit.pipe';
import { StringTruncatePipe } from './string-truncate.pipe';
import { StringPipe } from './string.pipe';
import { TrimFileExtensionPipe } from './trim-file-extension.pipe';

@NgModule({
  declarations: [
    TrimFileExtensionPipe,
    StringTruncatePipe,
    CapitalizeFirstLetterEachPipe,
    NoCommaPipe,
    PrintUnitPipe,
    RemoveUnitPipe,
    RemoveDoubleDecimalZeroPipe,
    KeepOnlyThreeMonthCharacterPipe,
    StringPipe,
  ],
  exports: [
    TrimFileExtensionPipe,
    StringTruncatePipe,
    CapitalizeFirstLetterEachPipe,
    NoCommaPipe,
    PrintUnitPipe,
    RemoveUnitPipe,
    RemoveDoubleDecimalZeroPipe,
    KeepOnlyThreeMonthCharacterPipe,
    StringPipe,
  ],
})
export class PipeModule {}
